import { render, staticRenderFns } from "./com-fold-cause.vue?vue&type=template&id=4f04dd61&scoped=true&"
import script from "./com-fold-cause.vue?vue&type=script&lang=js&"
export * from "./com-fold-cause.vue?vue&type=script&lang=js&"
import style0 from "./com-fold-cause.vue?vue&type=style&index=0&id=4f04dd61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f04dd61",
  null
  
)

export default component.exports